import * as moment from 'moment';

import { LOCAL_CURRENCY, LOCAL_PHONE_AREA, MAX_LENGTH_CURRENCY } from 'constants/form';
import { DEFAULT_LOCALE } from 'constants/locale';

export function formatAmount(value: number) {
  return value.toLocaleString(DEFAULT_LOCALE);
}

export function formatCurrency(value: string) {
  const prefix = LOCAL_CURRENCY + ' ';
  if (!value) {
    return prefix + 0;
  }

  const currency = value.toString().replace(/[^\d+]/g, '');
  const formattedAmount = formatAmount(Number(currency));
  return prefix + formattedAmount;
}

export function formatDate(value: string) {
  return moment.utc(value).locale(DEFAULT_LOCALE).format('DD MMMM');
}

export function formatE164Phone(value: string) {
  if (!value) {
    return '';
  }

  const phone = normalizePhone(value);
  if (phone.charAt(0) === '0') {
    return LOCAL_PHONE_AREA + phone.substring(1);
  }

  return phone;
}

export function formatInternationalPhone(value: string): string {
  if (!value) {
    return '';
  }

  const phone = normalizePhone(value);
  if (phone.charAt(0) === '+') {
    const phoneAreaLength = 3;
    return phone.substring(0, phoneAreaLength)
      + ' '
      + phone.substring(phoneAreaLength, phoneAreaLength * 2)
      + '-'
      + phone.substring(phoneAreaLength * 2, phoneAreaLength * 2 + 4)
      + '-'
      + phone.substring(phoneAreaLength * 2 + 4);
  } else if (phone.charAt(0) === '0') {
    const phoneWithE164Format = formatE164Phone(phone);
    return formatInternationalPhone(phoneWithE164Format);
  }

  return phone;
}

export function formatUsername(value: string) {
  if (isValidPhone(value)) {
    return formatE164Phone(value);
  }

  return value;
}

export function isValidEmail(email: string) {
  const mailformat = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return mailformat.test(email);
}

export function isValidPasswordFormat(value: string) {
  const regExp = /^(?=.*[a-zA-Z])(?=.*\d).+$/;
  const minLength = 6;
  return value && regExp.test(value) && value.length >= minLength;
}

export function isValidPhone(phone: string) {
  const phoneFormat = /^(^\+[1-9]{1,3}\s?|^0)(\d{3,4}-?){2}\d{3,4}$/;
  return phoneFormat.test(phone);
}

export function isValidUrl(url: string) {
  const urlFormat = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
  return urlFormat.test(url);
}

export function isValidUsername(value: string) {
  return isValidEmail(value) || isValidPhone(value);
}

export function maskBirthDate(value: string) {
  return [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
}

export function maskCurrency(value: string) {
  if (value.indexOf(LOCAL_CURRENCY + ' 0') > -1) {
    return value.split('').map((char) => {
      return char.match(/\d/) ? /\d/ : char;
    });
  }

  const thousandsSeparator = '.';
  const numberOfThousandDigit = 3;
  const normalizedAmount = normalizeCurrency(value).toString();
  const splittedLocalCurrency = LOCAL_CURRENCY.split('');
  const mask: Array<string | RegExp> = [...splittedLocalCurrency, ' ', /\d/, /\d/, /\d/];

  const resultOfModulus = normalizedAmount.length % numberOfThousandDigit;
  const numberOfThousandSeparators = Math.floor(normalizedAmount.length / numberOfThousandDigit);

  if (numberOfThousandSeparators > 0) {
    for (let i = 0; i < numberOfThousandDigit; i++) {
      mask.pop();
    }

    for (let i = 0; i < resultOfModulus; i++) {
      mask.push(/\d/);
    }

    for (let i = 0; i < numberOfThousandSeparators; i++) {
      if ((resultOfModulus > 0 && i === 0) || i > 0) {
        mask.push(thousandsSeparator);
      }
      for (let j = 0; j < numberOfThousandDigit; j++) {
        mask.push(/\d/);
      }
    }
  }

  return mask;
}

export function normalizeCurrency(value: string) {
  const amountInString = value.replace(/[^\d]+/g, '');
  if (amountInString.length > MAX_LENGTH_CURRENCY) {
    return Number(amountInString.substring(amountInString.length - MAX_LENGTH_CURRENCY));
  }
  return Number(amountInString);
}

export function normalizePhone(value: string) {
  if (!value) {
    return '';
  }

  return value.replace(/[^\d^+]/g, '');
}

export function setDefaultAmount(value: string) {
  if (!value) {
    return '0';
  }
  return value;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/helper/form.ts